// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text_intro .copy p{width:83.333333%;font-size:1.5rem;line-height:2rem;font-weight:200}@media screen and (max-width:767px){.text_intro .copy p{margin-top:1.25rem;width:100%;text-align:left;font-size:18px;line-height:1.5rem}}", ""]);
// Exports
module.exports = exports;
